module.exports = __webpack_public_path__ + "static/img/17.d8b0756.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/17.png
// module id = iK1F
// module chunks = 0